export interface MailTemplate {
  id?: number
  project_id: number,
  subject: string,
  text: string,
  type: string,
  use_dynamic_report?: boolean,
  report_pdf?: ReportPdf,
  mail_fields: {
    id?: number,
    name: string
  }[]
}

// Alle Felder, die im Vorlagen-Dialog angehakt werden koennen.
// Zentral gepflegt, damit Dialog, Formular und Speicherung nicht auseinanderlaufen
// (siehe bentomax/hawk#576 — die Liste lag vorher dreifach im Code).
// 'operation.add_report_photo' ist bewusst raus: die Checkbox war im Backend nie
// implementiert und von keiner einzigen Vorlage genutzt.
// 'operation.dont_send_report' ebenfalls: die Bremse ist durch report_pdf 'none'
// abgeloest (siehe bentomax/hawk#578).
export const MAIL_FIELD_KEYS: string[] = [
  'orderNr', 'status', 'reportLink', 'dateSLA', 'operationDate', 'tasks', 'priority', 'dateCreated',
  'externalOrderNr', 'description', 'project', 'store', 'address', 'deliveryNotes', 'contactName',
  'contactEmail', 'contactPhone', 'combined_report', 'operation.date', 'operation.status',
  'operation.technicians', 'operation.description', 'operation.report', 'operation.travelTimeStart',
  'operation.travelTimeEnd', 'operation.travelTime', 'operation.workingTimeStart',
  'operation.workingTimeEnd', 'operation.workingTime', 'operation.dateTravelStart',
  'operation.dateOnSite', 'operation.dateRepaired', 'operation.dateFinished', 'operation.distance',
  'operation.files',
];

// Welcher Einsatzbericht an die Mail geht. Loest die frueheren, voneinander
// abhaengigen Haken ab (bentomax/hawk#578).
export type ReportPdf = 'none' | 'legacy' | 'dynamic_2026';

export const REPORT_PDF_OPTIONEN: { wert: ReportPdf; label: string; hinweis: string }[] = [
  { wert: 'none', label: 'Gar keiner', hinweis: 'Es geht kein Einsatzbericht raus.' },
  { wert: 'legacy', label: 'Legacy-Format', hinweis: 'Der alte Einsatzbericht.' },
  { wert: 'dynamic_2026', label: 'Fassung 2026', hinweis: 'Der neue Einsatzbericht 2026.' },
];
